export default __webpack_public_path__ + "static/media/knox-security-black.4318f325.png";